module.exports = __webpack_public_path__ + "static/media/13_l_holsti1_1.41_47.5.de1a691e.png";